import { EBanksActionTypes } from '../../actions/banks';
import { TReduxActions } from '../../types/redux';
import { IBank } from '../../store/pik_data/banks';

export function banksReducer(state: IBank[] = [], action: TReduxActions) {
  if (action.type === EBanksActionTypes.SetBanks) {
    return [...action.payload];
  }

  return state;
}
